import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Wizard/wizard';
export var WizardFooter = function WizardFooter(_ref) {
  var children = _ref.children;
  return React.createElement("footer", {
    className: css(styles.wizardFooter)
  }, children);
};